import { Component, Input, OnInit, ElementRef } from '@angular/core';
import {
  IBillingAccount,
  billingAccountsService,
} from '@dch/billing-business-logic';
import { TranslationService, InceptionService } from '@dch/ng-common';
import { BillingAddressService } from '../../services/billing-address-service';

@Component({
  selector: 'my-bill-account-card',
  templateUrl: './my-bill-account-card.component.html',
  standalone: false,
})
export class MyBillAccountCardComponent implements OnInit {
  @Input() billingAccounts: Array<IBillingAccount>;
  @Input() billingAccount: IBillingAccount;
  addressLineOne = '';
  addressLineTwo = '';
  currentAccountAddress = '';
  otherAccountAddressList = [];
  hasSameAddressAsAnotherAccount = false;
  status?: string;
  statusTranslation?: string;
  singleAssociatedNumber = '';
  otherAssociatedNumbersList = [];
  otherAssociatedNumbersListLength: number;
  otherAssociatedNumbersListJoined = '';
  noFixedOrMobileTranslation: string;
  noProductLinkedTranslation: string;

  constructor(
    private billingAddressService: BillingAddressService,
    private translationService: TranslationService,
    private inceptionService: InceptionService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.getCurrentAccountAddress();
    this.getBalanceStatus();
    this.checkIfItHasSameAddressAsAnotherAccount();
    if (this.hasSameAddressAsAnotherAccount) {
      this.getAssociatedNumbers();
      setTimeout(() => {
        this.inceptionService.rsTooltip(this.elementRef);
      });
    }
  }

  private getCurrentAccountAddress(): void {
    if (this.billingAccount.address) {
      this.addressLineOne =
        this.billingAddressService.getResidenceStreetNumberAlphaFloorBox(
          this.billingAccount.address
        );
      this.addressLineTwo = this.billingAddressService.getCityLine(
        this.billingAccount.address
      );
      this.currentAccountAddress = this.addressLineOne + this.addressLineTwo;
    }
  }

  private checkIfItHasSameAddressAsAnotherAccount(): void {
    this.billingAccounts.forEach((account) => {
      if (account.address) {
        const fullAddress =
          this.billingAddressService.getResidenceStreetNumberAlphaFloorBox(
            account.address
          ) + this.billingAddressService.getCityLine(account.address);
        this.otherAccountAddressList.push(fullAddress);
      }
    });
    const countAddress = this.otherAccountAddressList.filter(
      (item) => item === this.currentAccountAddress
    ).length;
    this.hasSameAddressAsAnotherAccount = countAddress > 1;
  }

  private getBalanceStatus(): void {
    const balance = Number(this.billingAccount.balance);
    const overdueBalance = Number(this.billingAccount.overdueBalance);
    if (balance !== 0 && overdueBalance === 0) {
      this.status = 'open';
    } else if (balance === 0 && overdueBalance === 0) {
      this.status = 'noStatus';
    } else if (overdueBalance !== 0) {
      this.status = 'overdue';
    }
    this.statusTranslation = this.translationService.getTranslatedValueFor(
      `bills.redesign.accountCard.${this.status}`
    );
  }

  private getAssociatedNumbers(): void {
    this.noFixedOrMobileTranslation =
      this.translationService.getTranslatedValueFor(
        'bills.accountsView.noFixAndMobile'
      );
    this.noProductLinkedTranslation =
      this.translationService.getTranslatedValueFor(
        'bills.accountsView.noProductLinked'
      );

    const { mainAssociatedNumber, moreAssociatedNumbers } =
      billingAccountsService.transformAssociatedNumbers(
        this.billingAccount.associatedNumbers,
        this.noFixedOrMobileTranslation,
        this.noProductLinkedTranslation
      );
    this.singleAssociatedNumber = mainAssociatedNumber;
    if (
      this.singleAssociatedNumber === this.noFixedOrMobileTranslation &&
      this.billingAccount.associatedNumbers?.other
    ) {
      this.singleAssociatedNumber =
        this.billingAccount.associatedNumbers.other[0];
      if (this.billingAccount.associatedNumbers.other.length > 1) {
        this.otherAssociatedNumbersList.push(
          ...this.billingAccount.associatedNumbers.other.slice(1)
        );
      }
    }

    this.otherAssociatedNumbersListJoined = moreAssociatedNumbers.join(', ');
    this.otherAssociatedNumbersListLength = moreAssociatedNumbers.length;
  }
}
